<template lang="pug">
v-menu(v-model="open" offset-y transition="scroll-y-transition")
  template(#activator="{ on, attrs}")
    component(
      v-on="on"
      :is="toggleComponent"
      :class="classSpan"
      v-bind="$attrs"
    )
      span.mr-2.subtitle-1(v-if="prefix") {{ prefix }}
      span.subtitle-1 {{ valueText }}
      v-icon.rotate(:class="{ active: open}") mdi-chevron-down
  v-list
    v-list-item(
      v-for="item in items"
      :key="item.value"
      @click="$emit('input', item.value)"
    ) {{ item.name }}
</template>

<script>
export default {
  props: {
    items: { type: Array, required: true, default: () => [] },
    value: { type: [String, Number], required: false, default: null },
    prefix: { type: String, required: false, default: '' },
    classSpan: { type: String, required: false, default: '' },
    toggleComponent: { type: String, required: false, default: 'span' },
  },
  data() {
    return {
      open: false,
    };
  },
  computed: {
    valueText() {
      return (
        this.items.find((item) => item.value === this.value)?.name
        || this.items[0]?.name
      );
    },
  },
};
</script>

<style lang="scss">
.rotate {
  transition: all 0.2s;
  &.active {
    transform: rotate(-180deg);
  }
}
</style>
